import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import viewReducer from 'profile/ducks/view';
import portfolioReducer from 'profile/ducks/portfolio';
import specializationsReducer from 'profile/ducks/specializations';
import languagesReducer from 'profile/ducks/languages';
import imageEntriesReducer from 'profile/ducks/image_entries';
import nameEntriesReducer from 'profile/ducks/name_entries';
import * as shared from 'profile/ducks/shared';

const RootReducer = combineReducers({
  view: viewReducer,
  specializations: specializationsReducer,
  form: formReducer,
  portfolio: portfolioReducer,
  languages: languagesReducer,
  imageEntries: imageEntriesReducer,
  nameEntries: nameEntriesReducer
});

export { shared };
export default RootReducer;
